import RefNavbar from './RefNavbar';
import RefContact from './RefContact';

function Page2026Contact() {
  return (
    <>
      <RefNavbar />
      <RefContact />
    </>
  );
}

export default Page2026Contact;
